import React from 'react';
import { Link } from 'react-router-dom';
import { Checkbox } from './ui/checkbox';
import { Label } from './ui/label';
import { LEGAL_LINKS } from '../data/legalLinks';

/**
 * Единый чекбокс согласия на обработку ПДн (не предустановлен).
 * Для react-hook-form используйте FormField с этим компонентом через render prop.
 */
const PersonalDataConsent = ({
  id = 'pd-consent',
  checked = false,
  onCheckedChange,
  error,
  className = '',
}) => (
  <div className={className}>
    <div className="flex items-start gap-2">
      <Checkbox
        id={id}
        checked={checked}
        onCheckedChange={onCheckedChange}
        aria-invalid={Boolean(error)}
      />
      <Label htmlFor={id} className="text-sm font-normal leading-5 text-muted-foreground cursor-pointer">
        Даю согласие на обработку персональных данных в соответствии с{' '}
        <Link
          to={LEGAL_LINKS.privacy}
          className="text-accent hover:underline"
          onClick={(e) => e.stopPropagation()}
        >
          политикой
        </Link>
      </Label>
    </div>
    {error && <p className="text-sm text-destructive mt-1">{error}</p>}
  </div>
);

export default PersonalDataConsent;
